import commonService from "./common-service";

class PatientService {
  async getPatients(search = "", limit = 20, url = null) {
  try {
    const requestUrl =
      url || `Remote/v1/Patients/List?search=${search}&limit=${limit}`;

    const response = await commonService.getFromServer(requestUrl);

    if (response) {
      return {
        list: response?.response || [],
        nextUrl: response?.nextUrl || null,
      };
    } else {
      throw new Error("Error loading patients");
    }
  } catch (e) {
    throw new Error(e?.message || "Error loading patients");
  }
}


  async getPatientsList() {
    try {
      const response = await commonService.getFromServer("Remote/Patients/List", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getAllergies(search) {
    try {
      const response = await commonService.getFromServer("Remote/Allergies?search=" + search, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async releasePatients(list) {
    try {
      const response = await commonService.postToServer("Remote/Patients/Release", list);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async renewPatientMedication(list) {
    try {
      const response = await commonService.postToServer("Remote/RenewOrders", list);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async discontinueOrder(list) {
    try {
      const response = await commonService.postToServer("Remote/Patients/Medications/DC", list);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getStatus() {
    try {
      const response = await commonService.getFromServer(
        "Remote/Patients/Status",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getChargeAccounts(facId) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Patients/ChargeCodes?fac_id=" + facId,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getPatientsByID(id) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Patients/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadProfile(params) {
    try {
      const response = await commonService.postToServer(
        "Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createPatient(params) {
    try {
      var response;
      if (params?.id) {
        let id = params?.id;
        delete params.id;
        response = await commonService.updateToServer(
          "Remote/Patients/" + id,
          params
        );
      } else {
        response = await commonService.postToServer("Remote/Patients", params);
      }
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async deletePatient(id) {
    try {
      const response = await commonService.deleteToServer("Patient/" + id, {});

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting drug");
      }
    } catch (e) {
      throw new Error("Error deleting drug");
    }
  }
  async getPatient(id) {
    try {
      const response = await commonService.getFromServer(
        "PatientProfile/Patients",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getPatientDrugs(pat_id) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Patients/Medications/" + pat_id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getOrderDetails(rxNum) {
    try {
      const response = await commonService.getFromServer(
        "Remote/OrderDetail?rxf_id="+rxNum,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async releasePatientMedication(list) {
    try {
      const response = await commonService.postToServer("Remote/Patients/Medications/Release", list);
      if (response) {
        return response;
      } else {
        return Error("Error loading carriers");
      }
    } catch (e) {
      return Error(e);
    }
  }

  async submitClaims(list) {
    try {
      const response = await commonService.postToServer("ClaimService/ClaimSubmit", list);
      if (response) {
        return response;
      } else {
        return Error("Error loading carriers");
      }
    } catch (e) {
      return Error(e);
    }
  }
  async getScripts() {
    try {
      const response = await commonService.getFromServer(
        "ClaimService/ClaimOrders",
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getOldClaimScripts() {
    try {
      const response = await commonService.getFromServer(
        "ClaimService/OldClaimOrders",
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async submitOldClaims(list) {
    try {
      const response = await commonService.postToServer("ClaimService/OldClaimSubmit", list);
      if (response) {
        return response;
      } else {
        return Error("Error loading carriers");
      }
    } catch (e) {
      return Error(e);
    }
  }

  async submitRebillClaims(list) {
    try {
      const response = await commonService.postToServer("ClaimService/RebillClaimSubmit", list);
      if (response) {
        return response;
      } else {
        return Error("Error loading carriers");
      }
    } catch (e) {
      return Error(e);
    }
  }

  async submitRollovers(list) {
    try {
      const response = await commonService.postToServer("ClaimService/RolloverClaimSubmit", list);
      if (response) {
        return response;
      } else {
        return Error("Error loading carriers");
      }
    } catch (e) {
      return Error(e);
    }
  }

  async submitReverseClaim(params) {
    try {
      const response = await commonService.postToServer("ClaimService/ClaimReverse?rx_num="+params.rx_num + "&seq_num="+ params.seq_num,{} );
      if (response) {
        return response;
      } else {
        return Error("Error loading carriers");
      }
    } catch (e) {
      return Error(e.msg.errorMessage);
    }
  }
}
export default new PatientService();